
import toast from "react-hot-toast";
import {
    CUSTOMER_DETAIL,
    CUSTOMER_DETAIL_FAIL,
    CUSTOMER_DETAIL_SUCCESS,
    CUSTOMER_LIST,
    CUSTOMER_LIST_FAIL,
    CUSTOMER_LIST_SUCCESS,
    CUSTOMER_STATUS_CHANGE,
    CUSTOMER_STATUS_CHANGE_FAIL,
    CUSTOMER_STATUS_CHANGE_SUCCESS,
} from "../../actions/admin/customer-actions";

const initialState = {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    customerListStatistics: {},
    totalPages: 0,
    total: 0,
    customerList: [],
    customerDetail: null,
    customerDetailLoading: false,
    customerDetailError: null,
};

const customerReducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case CUSTOMER_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case CUSTOMER_LIST_SUCCESS: {
            return {
                ...state,
                customerList: payload.data.data,
                customerListStatistics: payload.data.customerCount,
                total: payload.data.total,
                totalPages: payload.data.totalPages,
                isLoading: false,
            };
        }

        case CUSTOMER_LIST_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }

        case CUSTOMER_DETAIL: {
            return {
                ...state,
                customerDetailLoading: true,
                customerDetailError: null,
                customerDetail: null,
            };
        }

        case CUSTOMER_DETAIL_SUCCESS: {
            return {
                ...state,
                customerDetail: payload?.data?.id ? payload.data : null,
                customerDetailLoading: false,
                customerDetailError: null,
            };
        }

        case CUSTOMER_DETAIL_FAIL: {
            const message =
                payload?.error?.data?.message ||
                payload?.error?.message ||
                "Failed to load customer";
            return {
                ...state,
                customerDetailLoading: false,
                customerDetailError: message,
            };
        }

        case CUSTOMER_STATUS_CHANGE: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case CUSTOMER_STATUS_CHANGE_SUCCESS: {
            toast.success(payload.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case CUSTOMER_STATUS_CHANGE_FAIL: {
            toast.error(payload.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        default: {
            return { ...state };
        }
    }
};

export default customerReducer;
